import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from "@ionic/angular";
import { JobParams } from '../job-follow-up/models/jobs';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-job-follow-up-wrapper',
    templateUrl: './job-follow-up-wrapper.component.html',
    styleUrls: ['./job-follow-up-wrapper.component.scss'],
})
export class JobFollowUpWrapperComponent implements OnInit {
    @Input() public cycleId: number;
    @Input() public title: string = 'job.follow-up.title';
    @Input() public jobGroup: number = 0;
    @Input() public pageComponentName: string = '';
    @Input() public filterByPage: boolean = true;
    public isEmailFeatureEnabled : boolean = false;

    public showEmailView: boolean = false;
    public selectedJob: JobParams;

    constructor(private _modalController: ModalController, private _configService: ConfigService) {
        this.isEmailFeatureEnabled = this._configService.settings.features.enableEmailSendModal;
    }

    ngOnInit() {
    }

    public onEmailRequested(job: JobParams): void {
        if (!this.isEmailFeatureEnabled) {
            return;
        }
        this.selectedJob = job;
        this.showEmailView = true;
    }

    public onGoBackToJobList(): void {
        this.showEmailView = false;
        this.selectedJob = null;
    }

    public onEmailSent(): void {
        // Quando o email for enviado com sucesso, voltar para a lista
        this.showEmailView = false;
        this.selectedJob = null;
    }

    public close(): void {
        this._modalController.dismiss();
    }
}
